// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"pp-z","selected":"qp-z"};